<template>
<div>

<nav class="navbar navbar-fixed-top">
        <div class="container-fluid">
            <div class="navbar-btn">
                <button type="button" class="btn-toggle-offcanvas"><i class="lnr lnr-menu fa fa-bars"></i></button>
            </div>

            <div class="navbar-brand">
                <a href="dashboard"><img src="../assets/img/logo-navbar.svg" alt="Lucid Logo" class="img-responsive logo"></a>                
            </div>
            
            <div class="navbar-right">
                <!-- <form id="navbar-search" class="navbar-form search-form">
                    <input value="" class="form-control" placeholder="Search here..." type="text">
                    <button type="button" class="btn btn-default"><i class="icon-magnifier"></i></button>
                </form>                -->

                <div id="navbar-menu">
                    <ul class="nav navbar-nav">                        
                        <!-- <li><a href="app-events.html" class="icon-menu d-none d-sm-block d-md-none d-lg-block"><i class="icon-calendar"></i></a></li> -->
                        <!-- <li><a href="app-chat.html" class="icon-menu d-none d-sm-block"><i class="icon-bubbles"></i></a></li> -->
                        <!-- <li><a href="app-inbox.html" class="icon-menu d-none d-sm-block"><i class="icon-envelope"></i><span class="notification-dot"></span></a></li> -->
                        <!-- <li class="dropdown">
                            <a href="javascript:void(0);" class="dropdown-toggle icon-menu" data-toggle="dropdown">
                                <i class="icon-bell"></i>
                                <span class="notification-dot"></span>
                            </a>
                            <ul class="dropdown-menu notifications animated shake">
                                <li class="header"><strong>You have 4 new Notifications</strong></li>
                                <li>
                                    <a href="javascript:void(0);">
                                        <div class="media">
                                            <div class="media-left">
                                                <i class="icon-info text-warning"></i>
                                            </div>
                                            <div class="media-body">
                                                <p class="text">Campaign <strong>Holiday Sale</strong> is nearly reach budget limit.</p>
                                                <span class="timestamp">10:00 AM Today</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>                               
                                <li>
                                    <a href="javascript:void(0);">
                                        <div class="media">
                                            <div class="media-left">
                                                <i class="icon-like text-success"></i>
                                            </div>
                                            <div class="media-body">
                                                <p class="text">Your New Campaign <strong>Holiday Sale</strong> is approved.</p>
                                                <span class="timestamp">11:30 AM Today</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                 <li>
                                    <a href="javascript:void(0);">
                                        <div class="media">
                                            <div class="media-left">
                                                <i class="icon-pie-chart text-info"></i>
                                            </div>
                                            <div class="media-body">
                                                <p class="text">Website visits from Twitter is 27% higher than last week.</p>
                                                <span class="timestamp">04:00 PM Today</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);">
                                        <div class="media">
                                            <div class="media-left">
                                                <i class="icon-info text-danger"></i>
                                            </div>
                                            <div class="media-body">
                                                <p class="text">Error on website analytics configurations</p>
                                                <span class="timestamp">Yesterday</span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li class="footer"><a href="javascript:void(0);" class="more">See all notifications</a></li>
                            </ul>
                        </li> -->
                        <li class="dropdown">
                            <a href="javascript:void(0);" class="dropdown-toggle icon-menu" data-toggle="dropdown"><i class="icon-equalizer"></i></a>
                            <ul class="dropdown-menu user-menu menu-icon animated bounceIn">
                                <li class="menu-heading">ACCOUNT SETTINGS</li>
                                <li><a href="javascript:void(0);"><i class="icon-note"></i> <span>Basic</span></a></li>
                                <!-- <li><a href="javascript:void(0);"><i class="icon-equalizer"></i> <span>Preferences</span></a></li>
                                <li><a href="javascript:void(0);"><i class="icon-lock"></i> <span>Privacy</span></a></li>
                                <li><a href="javascript:void(0);"><i class="icon-bell"></i> <span>Notifications</span></a></li> -->
                                <!-- <li class="menu-heading">BILLING</li>
                                <li><a href="javascript:void(0);"><i class="icon-credit-card"></i> <span>Payments</span></a></li>
                                <li><a href="javascript:void(0);"><i class="icon-printer"></i> <span>Invoices</span></a></li>                                
                                <li><a href="javascript:void(0);"><i class="icon-refresh"></i> <span>Renewals</span></a></li> -->
                            </ul>
                        </li>
                        <li><router-link to="" class="icon-menu" @click.native="logout"><i class="icon-login"></i></router-link></li>                        
                    </ul>
                </div>
            </div>
        </div>
    </nav>

    <div id="left-sidebar" class="sidebar">
        <div class="sidebar-scroll">
            <div class="user-account">
                <img src="../assets/img/user.png" class="rounded-circle user-photo" alt="User Profile Picture">
                <div class="dropdown">
                    <span>Welcome,</span>
                    <a href="javascript:void(0);" class="dropdown-toggle user-name" data-toggle="dropdown"><strong>Jessica Doe</strong></a>                    
                    <ul class="dropdown-menu dropdown-menu-right account animated flipInY">
                        <li><a href="page-profile2.html"><i class="icon-user"></i>My Profile</a></li>
                        <li><a href="app-inbox.html"><i class="icon-envelope-open"></i>Messages</a></li>
                        <li><a href="javascript:void(0);"><i class="icon-settings"></i>Settings</a></li>
                        <li class="divider"></li>
                        <li><a href="page-login.html"><i class="icon-power"></i>Logout</a></li>
                    </ul>
                </div>
            </div>
            <!-- Nav tabs -->
                
            <!-- Tab panes -->
            <div class="tab-content p-l-0 p-r-0">
                <div class="tab-pane animated fadeIn active" id="project_menu">
                    <nav class="sidebar-nav">
                        <ul class="main-menu metismenu">
                          <li v-for="(nav, navIndex) in navData" :key="navIndex">
                            <router-link v-if="nav.isHeader" to="" class="has-arrow"><i :class="nav.icon"></i><span>{{ nav.title }}</span></router-link>
                            <ul v-if="nav.isHeader">
                              <li v-for="(child, childIndex) in nav.child" :key="childIndex">
                                <router-link :to="{ name: child.url }"><i :class="child.icon"></i><span>{{ child.title }}</span></router-link>
                              </li>
                            </ul>
                            <router-link v-if="nav.isNav" class="nav-link" :to="{ name: nav.url }"><i :class="nav.icon"></i><span>{{ nav.title }}</span></router-link>
                          </li>
                        </ul>                        
                    </nav>                    
                </div>            
            </div>          
        </div>
    </div>

<!-- <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div id="logo-navbar"></div>
  <a class="navbar-brand" href="#">Sample Request</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li v-for="(nav, navIndex) in navData" :key="navIndex">
          <a v-if="nav.child.length !== 0" class="nav-link dropdown-toggle" href="#" :id="nav.title" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ nav.title }}
            <div v-if="nav.child.length > 0" class="dropdown-menu" :aria-labelledby="nav.title">
                <router-link v-for="(child, index) in nav.child" :key="index" :to="{ name: child.url }" class="dropdown-item" ><i :class="child.icon"></i> {{ child.title }}</router-link>
            </div>
          </a>
          <router-link v-if="nav.child.length === 0" class="nav-link" :to="{ name: nav.url }">{{ nav.title }}</router-link>
      </li>
      <li>
          <router-link to="" class="nav-link" @click.native="logout">Logout</router-link>
      </li>
    </ul>
  </div>
</nav> -->
</div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      navData: [
        {
          isNav: true,
          title: 'Dashboard',
          url: 'dashboard',
          icon: 'fas fa-chart-line',
          child: []
        },
        {
          isHeader: true,
          title: 'Task',
          icon: 'icon-notebook',
          child: [
            {
              isNav: true,
              title: 'QBO Admin',
              url: 'qboAdmin',
              icon: 'fas fa-file-signature'
            },
            {
              isNav: true,
              title: 'QBO Owner Area',
              url: 'areaOwner',
              icon: 'fas fa-file-signature'
            },
          ]
        },
        {
          isHeader: true,
          title: 'Report',
          icon: 'icon-book-open',
          child: [
            {
              isNav: true,
              title: 'Report Task',
              url: 'reportCPAR',
              icon: 'fas fa-chart-pie'
            },
          ]
        },
        {
          isHeader: true,
          title: 'Utility',
          icon: 'icon-settings',
          child: [
            {
              isNav: true,
              title: 'Employee',
              url: 'employee',
              icon: 'fas fa-user-tag'
            },
            {
              isNav: true,
              title: 'Submission Target',
              url: 'submissionTarget',
              icon: 'fas fa-percentage'
            },
            {
              isNav: true,
              title: 'Mail Management',
              url: 'mailManagement',
              icon: 'fas fa-envelope-open-text'
            },
            {
              isNav: true,
              title: 'Member Management',
              url: 'memberManagement',
              icon: 'fas fa-users-cog'
            },
            {
              isNav: true,
              title: 'User Profile',
              url: 'userProfile',
              icon: 'far fa-id-card'
            },
          ]
        }, 
      ]
    }
  },
  methods: {
    ...mapActions(['appLogout']),
    renderActiveLink(routeName) {
      return (this.$route.name === routeName) ? 'active' : ''
    },
    logout() {
      this.appLogout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>